export default "__VITE_ASSET__B$ZdeSEV__"